import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Card } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ContactUs = () => {
    const location = useLocation();
    const navigate = useNavigate();
    
    // Header'dan gelen service ismini yakalıyoruz, gelmezse 'Genel Proje' diyoruz
    const incomingSubject = location.state?.selectedService || 'Genel Proje';

    const [formData, setFormData] = useState({
        firmaAdi: '',
        name: '',
        email: '',
        phoneNumber: '',
        subject: incomingSubject, // Otomatik atandı
        message: ''
    });

    // Sayfa yüklendiğinde veya location değiştiğinde subject'i güncelle
    useEffect(() => {
        if (location.state?.selectedService) {
            setFormData(prev => ({ ...prev, subject: location.state.selectedService }));
        }
    }, [location]);

    const validateEmail = (email) => {
        return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        const { name, email, subject, message, phoneNumber, firmaAdi } = formData;

        if (!name || !email || !message || !phoneNumber || !firmaAdi) {
            alert('Lütfen tüm alanları doldurunuz.');
            return;
        }

        if (!validateEmail(email)) {
            alert('Lütfen geçerli bir e-posta adresi giriniz.');
            return;
        }
        
        try {
            await axios.post('/api/orders/contact', { 
                name: `${name} (${firmaAdi})`,
                email, 
                subject, 
                message, 
                phoneNumber 
            });
            
            alert('Mesajınız başarıyla gönderildi.');
            navigate('/'); 
            
        } catch (err) {
            alert('Bir hata oluştu. Lütfen tekrar deneyin.');
        }
    };

    return (
        <Container className="d-flex justify-content-center py-5">
            <Card style={{ width: '100%', maxWidth: '500px', borderRadius: '25px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                <Card.Body className="p-4">
                    <h3 className="text-center mb-4" style={{ color: '#2b2b2b', fontWeight: 'bold' }}>Proje Talep Formu</h3>
                    <Form onSubmit={submitHandler}>
                        
                        {/* KONU BAŞLIĞI (OTOMATİK VE DEĞİŞTİRİLEMEZ) */}
                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontWeight: 'bold', color: '#666', fontSize: '0.8rem', marginLeft: '10px' }}>İlgili Hizmet</Form.Label>
                            <Form.Control 
                                type="text" 
                                value={formData.subject} 
                                readOnly 
                                style={{ height: '60px', borderRadius: '12px', backgroundColor: '#f8f9fa', fontWeight: 'bold', color: '#2b2b2b' }} 
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Control type="text" placeholder="Firma İsmi" 
                                value={formData.firmaAdi}
                                onChange={(e) => setFormData({...formData, firmaAdi: e.target.value})}
                                style={{ height: '60px', borderRadius: '12px' }} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Control type="text" placeholder="Adı Soyadı" 
                                value={formData.name}
                                onChange={(e) => setFormData({...formData, name: e.target.value})}
                                style={{ height: '60px', borderRadius: '12px' }} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Control type="email" placeholder="E-posta" 
                                value={formData.email}
                                onChange={(e) => setFormData({...formData, email: e.target.value})}
                                style={{ height: '60px', borderRadius: '12px' }} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Control type="text" placeholder="Telefon" 
                                value={formData.phoneNumber}
                                onChange={(e) => setFormData({...formData, phoneNumber: e.target.value})}
                                style={{ height: '60px', borderRadius: '12px' }} />
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Control as="textarea" rows={4} placeholder="Proje detaylarını buraya yazınız..." 
                                value={formData.message}
                                onChange={(e) => setFormData({...formData, message: e.target.value})}
                                style={{ borderRadius: '12px' }} />
                        </Form.Group>

                        <Button type="submit" className="w-100" 
                            style={{ backgroundColor: '#2b2b2b', border: 'none', height: '60px', borderRadius: '30px', fontSize: '1.1rem', fontWeight: 'bold' }}>
                            Talebi Gönder
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default ContactUs;
